'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { usePrV2Discussion } from '@/data/v2/pr/use-pr-v2-discussion';
import { useVercelPreviewStore } from '@/lib/stores/vercel-preview-store';
import { resolveVercelPreviewUrl } from '@/lib/vercel/preview-detection';
type PrV2VercelPreviewListenerProps = {
  owner: string;
  repo: string;
  number: string;
};

/** Watches PR V2 discussion and stores the latest Vercel preview URL. */
export function PrV2VercelPreviewListener(t0) {
  const $ = _c(9);
  const {
    owner,
    repo,
    number
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      enabled: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const discussionQuery = usePrV2Discussion(owner, repo, number, t1);
  const timelineItems = discussionQuery.data?.timelineItems;
  const setPreviewUrl = useVercelPreviewStore(_temp);
  let t2;
  let t3;
  if ($[1] !== discussionQuery.isSuccess || $[2] !== number || $[3] !== owner || $[4] !== repo || $[5] !== setPreviewUrl || $[6] !== timelineItems) {
    t2 = () => {
      if (!discussionQuery.isSuccess) {
        return;
      }
      const resolution = resolveVercelPreviewUrl(timelineItems ?? []);
      if (resolution.kind === "valid") {
        setPreviewUrl(owner, repo, number, resolution.url);
        return;
      }
      if (resolution.kind === "no_candidate") {
        setPreviewUrl(owner, repo, number, null);
      }
    };
    t3 = [discussionQuery.isSuccess, timelineItems, owner, repo, number, setPreviewUrl];
    $[1] = discussionQuery.isSuccess;
    $[2] = number;
    $[3] = owner;
    $[4] = repo;
    $[5] = setPreviewUrl;
    $[6] = timelineItems;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  return null;
}
function _temp(state) {
  return state.setPreviewUrl;
}